import { TOKEN_AGGREGATION_BASE } from '@/config';

export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/** Try primary URL, then /token-aggregation prefix on same origin, then public explorer hosts. */
function aggregationBases(): string[] {
  const primary = TOKEN_AGGREGATION_BASE.replace(/\/$/, '');
  let origin = '';
  try {
    origin = new URL(primary).origin;
  } catch {
    /* ignore */
  }
  const list = [
    primary,
    ...(origin ? [`${origin}/token-aggregation`] : []),
    'https://explorer.d-bis.org',
    'https://explorer.d-bis.org/token-aggregation',
  ].filter(Boolean);
  return [...new Set(list)];
}

export async function fetchApi<T>(path: string): Promise<T> {
  const p = path.startsWith('/') ? path : `/${path}`;
  let last: Error | null = null;
  for (const base of aggregationBases()) {
    const url = `${base}${p}`;
    try {
      const res = await fetch(url);
      if (!res.ok) {
        const text = await res.text().catch(() => '');
        last = new ApiError(text || res.statusText, res.status);
        continue;
      }
      return res.json() as Promise<T>;
    } catch (e) {
      last = e instanceof Error ? e : new Error(String(e));
    }
  }
  throw last || new Error('All token-aggregation API bases failed');
}
